module.exports = __webpack_public_path__ + "static/img/240.97a2a873.png";